import { IApiService } from 'web_core_library';
import { EArticleAlias, IArticlesResponsePayload } from '../types';

export function createLegalsService() {
  let ApiService: IApiService;

  /**
   * request legals articles
   * id: 'help_center_alias'
   * method: 'GET'
   */
  const requestTouArticles = (articleAlias: EArticleAlias, country: string, language?: string) => {
    return ApiService.action<IArticlesResponsePayload>('help_center_alias', {
      urlParams: { articleAlias },
      method: 'get',
      params: {
        language,
        country,
      },
    });
  };

  const getCountriesList = () => {
    return ApiService.action('countries', {
      method: 'get',
    });
  };

  const service = {
    init: (ApiServiceInstance: IApiService) => {
      ApiService = ApiServiceInstance;
    },
    requestTouArticles,
    getCountriesList,
  };
  return service;
}

const LegalsService = createLegalsService();
export default LegalsService;
